import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=d57130f0&scoped=true&"
import script from "./UserForm.vue?vue&type=script&lang=js&"
export * from "./UserForm.vue?vue&type=script&lang=js&"
import style0 from "./UserForm.vue?vue&type=style&index=0&id=d57130f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57130f0",
  null
  
)

export default component.exports